import { datadogRum } from '@datadog/browser-rum'

declare global {
  interface Window {
    isBarcodeDetectorNative: boolean | undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    BarcodeDetector: any
  }
}

export const featureFlag = 'hardwareBarcodeScannerFeatureFlagV2'

export const loadPolyfills = (): Promise<void> =>
  new Promise((resolve) => {
    const doImport = () => {
      datadogRum.addAction('is-scanner-native', { message: 'No' })

      import('./ZXingBarcodeDetector')
        .then((module) => {
          window.isBarcodeDetectorNative = false
          window.BarcodeDetector = module.default

          resolve()
        })
        .catch((err) => {
          datadogRum.addAction('is-scanner-native', { message: `Failed: ${err.message}` })

          // When polyfill fails, resolve anyway
          resolve()
        })
    }

    if (localStorage && localStorage.getItem(featureFlag) !== 'true') {
      doImport()
    } else if ('BarcodeDetector' in window) {
      window.BarcodeDetector.getSupportedFormats().then((formats: string[]) => {
        const isSupported = (format: string) => formats.includes(format)

        if (isSupported('code_39') && isSupported('code_128') && isSupported('itf') && isSupported('qr_code')) {
          datadogRum.addAction('is-scanner-native', { message: 'Yes' })

          window.isBarcodeDetectorNative = true

          resolve()
        } else {
          doImport()
        }
      })
    } else {
      doImport()
    }
  })
